import React, { useEffect, useState } from 'react';
import logo from './images/logo.png';
import country from './images/country.png';
import forge from 'node-forge';
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from '../../hooks/useAuth';

import Constants from '../../constants/Constants';
import AppRoutes from '../../constants/AppRoutes';
import Messages from '../../constants/Messages';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ErrorUtils from '../../utilities/error-utils';
import LoginValidations, { encryptData } from '../../utilities/login-validations';

import FormField from '../../containers/form-field/form-field';
import Input from '../../components/form-elements/input';
import Button from '../../components/form-elements/button';
import Loader from '../../components/loader/loader';

import AuthenticationService from '../../services/authentication-service';


const Login = () => {
    const [loader, setLoader] = useState(false);
    const [email, setEmail] = useState();
    const [password, setPassword] = useState();
    const [publicEncryptionKey, setPublicEncryptionKey] = useState();
    const [validationErrors, setValidationErrors] = useState({
        email : null,
        password : null
    });
    const navigate = useNavigate();
    const { isAuth, authLogin, authLogout } = useAuth();

    useEffect(() => {
        if(isAuth) {
            navigate(AppRoutes.HOME);
            return;
        }
        // Fetching the RSA public key for encryption.
        (async () => {
            try{
                let getPublicEncryptionKey =  await AuthenticationService.getPublicKey();
                if (getPublicEncryptionKey?.isSuccess) {
                    setPublicEncryptionKey(getPublicEncryptionKey.publicKey)
                }
            } catch(error) {
                toast.error(error.message);
            }
          })();
    },[]);

    /** ---------------------------------------------------------------
     * Method : Login
     * Description : 
     */
    const login = async () => {
        // client side validation
        const validateEmailErrors = LoginValidations.validateEmail(email);
        const validatePasswordErrors = LoginValidations.validatePassword(password);
        setValidationErrors({
            email : validateEmailErrors,
            password : validatePasswordErrors
        });
        
        if(validateEmailErrors == null && validatePasswordErrors == null){
            setLoader(true);
            // Call Login API
            try{
                const loginCredentials = JSON.stringify({email: email, password: password});
                // Encrypting the credentials using RSA public key.
                if ( publicEncryptionKey ) {
                    const encryptedBase64LoginData = encryptData(publicEncryptionKey,loginCredentials)
                    const authenticationResponse = await AuthenticationService.login(encryptedBase64LoginData);
                    if(authenticationResponse.isSuccess) {
                        authLogin();
                        setLoader(false);
                        if(authenticationResponse.userRole === Constants.USER_ROLES.EMPLOYEE){
                            navigate(AppRoutes.HOME);
                        } else {
                            navigate(AppRoutes.PROFILE);
                        }
                    } else {
                        // To Do : Set errors on DOM, May be show red border on email and password
                    }
                }
                else {
                    toast.error(Messages.ERROR_CODES.INVALID_PUBLIC_KEY.message);
                }
            } catch (error) {
                if(error.code === Messages.ERROR_CODES.INVALID_JWT.code) {
                    navigate(AppRoutes.LOGIN);
                } else {
                    toast.error(error.message);
                }
            }
            setLoader(false);
        }
    };

    /** ---------------------------------
     * Method : Email Input Change
     */
    const onEmailChange = (e) => {
        setEmail(e.target.value);
    };

    /** ---------------------------------
     * Method : Password Input Change
     */
    const onPasswordChange = (e) => {
        setPassword(e.target.value);
    };
    return (
        <div className="p-8 pt-10 max-w-lg mx-auto bg-white h-screen">
            <div className='mx-auto w-32 mb-4'>
                <img src = {logo}  alt = "Logo"/>
            </div>
            <h1 className='text-4xl text-center font-bold tracking-widest'>{Messages.LOGIN.TITLE}</h1>

            <div className='mt-10'>
                <h1 className='font-bold'>{Messages.LOGIN.SIGN_IN_MESSAGE}</h1>
                <FormField label = {Messages.LOGIN.FORM_FIELDS.EMAIL.LABEL} labelClass = "text-sm" error = {validationErrors.email}>
                    <Input type = "email" onChange = {onEmailChange} />
                </FormField>
                <FormField label = {Messages.LOGIN.FORM_FIELDS.PASSWORD.LABEL} labelClass = "text-sm"  error = {validationErrors.password}>
                    <Input type = "password" onChange = {onPasswordChange}/>
                </FormField>
                <FormField>
                    <Button size = "full" onClick = {login}>{Messages.LOGIN.FORM_FIELDS.SIGN_IN}</Button>
                </FormField>
            </div>

            <p className='text-xs'>
                <span className='font-bold'>{Messages.LOGIN.FORM_FIELDS.FORGOT_PASSWORD.LABEL}</span>
                <Link to={AppRoutes.FORGOT_PASSWORD}>{Messages.LOGIN.FORM_FIELDS.FORGOT_PASSWORD.ACTION}</Link>
            </p>

            <Loader show = {loader} fullPage = {true} message = {Messages.LOGIN.SIGNING_YOU_IN}/>
            <ToastContainer/>

            <div className='fixed items-center flex w-full left-0 bottom-0 p-4 bg-gray-100 text-black text-xs'>
                <div className='mr-2'>
                    <img src={country} className='w-6'/>
                </div>  
                {Messages.LOGIN.APP_ACCESS_MESSAGE_BANNER}
            </div>
        </div>
    )
}

export default Login;





